import { SERVER_URL } from "../../../utils/constants";
import HttpRequest from "../../../utils/HttpRequest";

export const getProductItemsService = async (query: string, token: string) => {
  return await HttpRequest.get(`${SERVER_URL}/productitem${query}`, token);
};

export const getStockService = async (query: string, token: string) => {
  return await HttpRequest.get(`${SERVER_URL}/stock${query}`, token);
};

export const updateProductItemService = async (
  productItemId: string,
  data: any,
  token: string
) => {
  return await HttpRequest.update(
    `${SERVER_URL}/productitem/one/${productItemId}`,
    data,
    token
  );
};

export const addProductItemService = async (data: any, token: string) => {
  return await HttpRequest.post(`${SERVER_URL}/productitem`, data, token);
};

export const getProductItemHistoryService = async (
  productItemId: string,
  token: string
) => {
  return await HttpRequest.get(
    `${SERVER_URL}/productitem/history/${productItemId}`,
    token
  );
};

export const deleteProductItemService = async (
  productItemId: string,
  token: string
) => {
  return await HttpRequest.delete(
    `${SERVER_URL}/productitem/one/${productItemId}`,
    token
  );
};
